
import React from 'react';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

import ChatController from '../../../controllers/Chat';

import ExternalConfiguration from '../../../external-configuration';

import './SocialLogin.css';

const msgHandler = msgable => {   // REVIEW REDUNDANTE en todos los formularios, SocialLogin y ChatSidebar
  if( msgable.msg) alert( msgable.msg);
}

const errorHandler = async executable => {
  try {
    await executable();
  } catch( error) {
    msgHandler( error);
  }
}

const NetworkKeys = {
  Google: 'google+',
  Facebook: 'facebook',
  Unknown: 'unknown',
};

const getGoogleClientId = _ => {
  const GoogleIds = ExternalConfiguration.Credentials.Chat.GoogleIds;
  const hostname = window.location.hostname;
  if( hostname in GoogleIds) return GoogleIds[ hostname];
  console.warn( new Date(), 'Hostname not registered on google, loading with google unavailable.');
  return null;
};

const processData = data => {
  let userName, socialId, mail;
  if( 'name' in data) userName = data.name;               // facebook
  if( 'id' in data) socialId = data.id;                   // facebook
  if( 'email' in data) mail = data.email;                 // facebook
  if( 'El' in data) socialId = data.El;                   // google
  if( 'googleId' in data) socialId = data.googleId;       // google
  if( 'profileObject' in data) {                              // google
    if( 'name' in data.profileObject) userName = data.profileObject.name;
    if( 'googleId' in data.profileObject) socialId = data.profileObject.googleId;
    if( 'email' in data.profileObject) mail = data.profileObject.email;
  }
  if( 'profileObj' in data) {                                 // google
    if( 'name' in data.profileObj) userName = data.profileObj.name;
    if( 'googleId' in data.profileObj) socialId = data.profileObj.googleId;
    if( 'email' in data.profileObj) mail = data.profileObj.email;
  }

  return { userName, socialId, mail };
};

const SocialLogin = props => {
  const googleClientId = getGoogleClientId();   // REVIEW si es null el boton deberia estar en disabled
  const facebookAppId = ExternalConfiguration.Credentials.Chat.FacebookAppId;

  const onLogin = async (data, network = NetworkKeys.Unknown) => {
    const { userName, socialId, mail } = processData( data);

    await errorHandler( async () => {
      const response = await ChatController.socialLogin( props.chatConfiguration, userName, socialId, mail, network);
      // msgHandler( response);   // DEBUG
      props.setLogin( response.sessionToken);
    });
  };

  return (
    <div className={'row'}>
      <label>SOCIAL LOGIN</label>
      <FacebookLogin
        //className={'btn-social-media'}
        appId={ facebookAppId }
        fields='name,email'
        // autoLoad={true}
        // onClick={componentClicked}
        cssClass={'btn-social-media btn-facebook'}
        // size='small'
        icon='fa-facebook-square'
        textButton=''
        callback={ data => onLogin( data, NetworkKeys.Facebook) }
      />
      <GoogleLogin
        clientId={ googleClientId }
        buttonText=''
        className={'google-button fa fa-google-plus-square btn-margin btn-social-media'}
        onSuccess={ data => onLogin( data, NetworkKeys.Google) }
        //  onFailure={responseGoogle}
        disabled={ !googleClientId }
      />
      <button className={'cancel pull-right'} onClick={ props.clearForm }> X </button>
    </div>
  );
};

export default SocialLogin;
